export default {
  buttons: {
    create: 'Luo',
    update: 'Päivitä',
    cancel: 'Peruuta',
  },
  fields: {
    title: {
      label: 'Otsikko',
      placeholder: 'Kirjoita otsikko',
    },
    description: {
      label: 'Kuvaus',
      placeholder: 'Kirjoita kuvaus',
    },
    button_text: {
      label: 'Painikkeen teksti',
      placeholder: 'Kirjoita painikkeen teksti',
    },
    button_url: {
      label: 'Painikkeen URL',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Kuva',
    },
  },
  title: 'Luo julkaisu',
};
